/* Imagine Surfaces — theme controllers (vanilla JS, no framework) */
(function () {
  'use strict';

  /* ---------- Sticky header background shift on scroll ---------- */
  function initStickyHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 80);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Mega-menu (hover, 140ms grace before close) ---------- */
  function initMegaMenu() {
    var root = document.querySelector('[data-megamenu-root]');
    var menu = document.querySelector('[data-megamenu]');
    var trigger = document.querySelector('[data-megamenu-trigger]');
    if (!root || !menu || !trigger) return;

    var closeTimer = null;
    var open = function () {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      menu.hidden = false;
      // next frame so the transition runs
      requestAnimationFrame(function () { menu.classList.add('is-open'); });
      trigger.setAttribute('aria-expanded', 'true');
    };
    var close = function () {
      closeTimer = setTimeout(function () {
        menu.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        var hide = function () { menu.hidden = true; menu.removeEventListener('transitionend', hide); };
        menu.addEventListener('transitionend', hide);
      }, 140);
    };

    [root, menu].forEach(function (el) {
      el.addEventListener('mouseenter', open);
      el.addEventListener('mouseleave', close);
    });
    trigger.addEventListener('focus', open);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- Mobile drawer ---------- */
  function initMobileMenu() {
    var openBtn = document.querySelector('[data-mobile-open]');
    var menu = document.querySelector('[data-mobile-menu]');
    if (!openBtn || !menu) return;
    var closeBtn = menu.querySelector('[data-mobile-close]');
    var show = function () { menu.hidden = false; document.body.style.overflow = 'hidden'; };
    var hide = function () { menu.hidden = true; document.body.style.overflow = ''; };
    openBtn.addEventListener('click', show);
    if (closeBtn) closeBtn.addEventListener('click', hide);
    menu.addEventListener('click', function (e) { if (e.target === menu) hide(); });
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    var els = document.querySelectorAll('[data-reveal], .reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var delay = parseInt(entry.target.getAttribute('data-reveal-delay') || '0', 10);
          setTimeout(function () { entry.target.classList.add('is-in'); }, delay);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Newsletter (posts to Google Sheet endpoint when configured) ---------- */
  function initNewsletter() {
    document.querySelectorAll('[data-newsletter]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        var msg = form.parentNode.querySelector('[data-newsletter-msg]');
        if (!form.getAttribute('action')) {
          // No endpoint configured yet — prevent navigation, show notice.
          e.preventDefault();
          if (msg) { msg.hidden = false; msg.textContent = 'Thank you — signup is being connected. Please email us in the meantime.'; }
          return;
        }
        // With an action set, allow normal POST (Apps Script accepts form posts).
        if (msg) { msg.hidden = false; msg.textContent = 'Thank you for subscribing.'; }
      });
    });
  }

  /* ---------- Generic accordion (FAQ, product detail) ---------- */
  function initAccordions() {
    document.querySelectorAll('[data-accordion] [data-accordion-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-accordion-item]');
        if (!item) return;
        var isOpen = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
  }

  function init() {
    initStickyHeader();
    initMegaMenu();
    initMobileMenu();
    initReveal();
    initNewsletter();
    initAccordions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
